/* Package JSON Import will be here */
import React from 'react';
import { connect } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';
import { Constants } from '../../../config/appConstants';
/* Package JSON Import will be here */
class AuthenticateRoute extends Route {   
    render() {
        if (this.props.user.roleName && this.props.authorizedClaim && this.props.user.claimValue.includes(this.props.authorizedClaim)) {
            return (
                <Route component={this.props.component}
                    path={this.props.path} />
            );
        }
        else if(this.props.user.loggedOutUserRole === Constants.SYSTEM_ADMIN_ROLE_NAME) 
        {
            return (
                <Redirect to={{ pathname: '/admin' }} />
            );
        }
        else {                 
           return (
               <Redirect to={{ pathname: '/Login' }} />
           );
        }
    }
}
function mapStateToProps(state) { return { user: state.loginReducer.user }; }
export default connect(mapStateToProps)(AuthenticateRoute);